import { Toaster } from "components/notification/Toaster";
import { COM_WITHOUT_BILLING_SETUP, COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET, COM_WITHOUT_DEFAULT_PRODUCT } from "constants/billingSetupReport";
import { func_serviceHandling, isNumberValid } from "functions";
import { useDispatch } from "react-redux";
import {
    addProductLevel1_failure,
    getMonthlyRecursiveCommissionList_failure,
    addProductLevel1_request,
    addProductLevel1_success,
    addProductLevel2_failure,
    addProductLevel2_request,
    addProductLevel2_success,
    deleteProductLevel1_failure,
    deleteProductLevel1_request,
    deleteProductLevel1_success,
    deleteProductLevel2_failure,
    deleteProductLevel2_request,
    deleteProductLevel2_success,
    getLevel1EnabledProductDetailList_failure,
    getLevel1EnabledProductDetailList_request,
    getLevel1EnabledProductDetailList_success,
    getLevel2CommissionPercentage_failure,
    getLevel2CommissionPercentage_request,
    getLevel2CommissionPercentage_success,
    getLevel2EnabledProductDetailList_failure,
    getLevel2EnabledProductDetailList_request,
    getLevel2EnabledProductDetailList_success,
    getNewOutletCommissionList_failure,
    getNewOutletCommissionList_request,
    getNewOutletCommissionList_success,
    updateLevel2CommissionPercentage_failure,
    updateLevel2CommissionPercentage_request,
    updateLevel2CommissionPercentage_success,
    getMonthlyRecursiveCommissionList_request,
    getMonthlyRecursiveCommissionList_success,
    getCreditNoteCommissionList_request,
    getCreditNoteCommissionList_success,
    getCreditNoteCommissionList_failure,
    getInvoiceCommissionList_request,
    getInvoiceCommissionList_success,
    getInvoiceCommissionList_failure,
    updateInvoiceReportingData_request,
    updateInvoiceReportingData_success,
    updateInvoiceReportingData_failure,
    updateCreditNoteReportingData_request,
    updateCreditNoteReportingData_success,
    updateCreditNoteReportingData_failure,
    getInvoiceCommissionDrillDownList_request,
    getInvoiceCommissionDrillDownList_success,
    getInvoiceCommissionDrillDownList_failure,
    getCreditNoteCommissionDrillDownList_request,
    getCreditNoteCommissionDrillDownList_success,
    getCreditNoteCommissionDrillDownList_failure,
    getBillingSetupReport_request,
    getBillingSetupReport_success,
    getBillingSetupReport_failure,
    getPOSCountReport_request,
    getPOSCountReport_success,
    getPOSCountReport_failure,
    getTrialCOMReport_request,
    getTrialCOMReport_success,
    getTrialCOMReport_failure,
    getAllPOSCountReport_request,
    getAllPOSCountReport_success,
    getAllPOSCountReport_failure,
    getStoreReport_request,
    getStoreReport_success,
    getStoreReport_failure,
    getFullStoreReport_request,
    getFullStoreReport_success,
    getFullStoreReport_failure,
    getActivationLogReport_request,  // Add this
    getActivationLogReport_success,  // Add this
    getActivationLogReport_failure,   // Add this
    getApiUsageReport_request,
    getApiUsageReport_success,
    getApiUsageReport_failure
} from "../slices/reporting.slices";
import usePromiseInstance_authorization from "./config";

export default function useReporting() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function getLevel1EnabledProductDetailList(productCode, agentType = "Salesperson") {
        dispatch(getLevel1EnabledProductDetailList_request());
        
        let paramObj = {
            agentType,
            commissionLevel: "Level1",
            productCode,
        }

        let url = func_serviceHandling.createUrlWithParams('/Report/GetEnabledCommissionProduct', paramObj);

        request(getLevel1EnabledProductDetailList_request, (axios) => {
            axios.get(url)
                .then((response) => {
                    dispatch(getLevel1EnabledProductDetailList_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load enabled product list";
                    Toaster({ type: "error", msg });

                    dispatch(getLevel1EnabledProductDetailList_failure(msg));
                })
        })
    }

    function addProductLevel1(productDetails, agentType = "Salesperson") {
        dispatch(addProductLevel1_request());

        let paramObj = {
            agentType,
            commissionLevel: "Level1",
        }

        let url = func_serviceHandling.createUrlWithParams('/Report/AddCommissionProduct', paramObj);

        request(addProductLevel1_request, (axios) => {
            axios.post(url, productDetails)
                .then((response) => {
                    dispatch(addProductLevel1_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add product(s)";
                    Toaster({ type: "error", msg });

                    dispatch(addProductLevel1_failure(msg));
                })
        })
    }

    function deleteProductLevel1(productIds, agentType = "Salesperson") {
        dispatch(deleteProductLevel1_request());

        let paramObj = {
            agentType,
            commissionLevel: "Level1",
        }

        let url = func_serviceHandling.createUrlWithParams('/Report/DeleteCommissionProduct', paramObj);

        request(deleteProductLevel1_request, (axios) => {
            axios.delete(url, {
                data: productIds
            })
                .then((response) => {
                    dispatch(deleteProductLevel1_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete product(s)";
                    Toaster({ type: "error", msg });

                    dispatch(deleteProductLevel1_failure(msg));
                })
        })
    }

    function getLevel2EnabledProductDetailList(productCode, agentType = "Salesperson") {
        dispatch(getLevel2EnabledProductDetailList_request());

        let paramObj = {
            agentType,
            commissionLevel: "Level2",
            productCode,
        }

        let url = func_serviceHandling.createUrlWithParams('/Report/GetEnabledCommissionProduct', paramObj);

        request(getLevel2EnabledProductDetailList_request, (axios) => {
            axios.get(url)
                .then((response) => {
                    dispatch(getLevel2EnabledProductDetailList_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load enabled product list";
                    Toaster({ type: "error", msg });

                    dispatch(getLevel2EnabledProductDetailList_failure(msg));
                })
        })
    }

    function getLevel2CommissionPercentage(agentType = "Salesperson") {
        dispatch(getLevel2CommissionPercentage_request());

        request(getLevel2CommissionPercentage_request, (axios) => {    
            axios.get(`/Report/GetCommissionPercentage/${agentType}`)
                .then((response) => {
                    dispatch(getLevel2CommissionPercentage_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load commission percentage";
                    Toaster({ type: "error", msg });

                    dispatch(getLevel2CommissionPercentage_failure(msg));
                })
        })
    }
    
    function addProductLevel2(productDetails, agentType = "Salesperson") {
        dispatch(addProductLevel2_request());

        let paramObj = {
            agentType,
            commissionLevel: "Level2",
        }

        let url = func_serviceHandling.createUrlWithParams('/Report/AddCommissionProduct', paramObj);

        request(addProductLevel2_request, (axios) => {
            axios.post(url, productDetails)
                .then((response) => {
                    dispatch(addProductLevel2_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add product";
                    Toaster({ type: "error", msg });

                    dispatch(addProductLevel2_failure(msg));
                })
        })
    }

    function deleteProductLevel2(productIds, agentType = "Salesperson") {
        dispatch(deleteProductLevel2_request());

        let paramObj = {
            agentType,
            commissionLevel: "Level2",
        }

        let url = func_serviceHandling.createUrlWithParams('/Report/DeleteCommissionProduct', paramObj);

        request(deleteProductLevel2_request, (axios) => {
            axios.delete(url, {
                data: productIds
            })
                .then((response) => {
                    dispatch(deleteProductLevel2_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete product";
                    Toaster({ type: "error", msg });

                    dispatch(deleteProductLevel2_failure(msg));
                })
        })
    }

    function updateLevel2CommissionPercentage(newCommission, agentType = "Salesperson") {
        dispatch(updateLevel2CommissionPercentage_request());

        let paramObj = {
            newCommission,
        }

        let url = func_serviceHandling.createUrlWithParams(`/Report/UpdateCommissionPercentage/${agentType}`, paramObj);

        request(updateLevel2CommissionPercentage_request, (axios) => {
            axios.put(url)
                .then((response) => {
                    dispatch(updateLevel2CommissionPercentage_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update commission percentage";
                    Toaster({ type: "error", msg });

                    dispatch(updateLevel2CommissionPercentage_failure(msg));
                })
        })
    }

    function getInvoiceCommissionList(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getInvoiceCommissionList_request());

        request(getInvoiceCommissionList_request, (axios) => {
            
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;

            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions,
            }
    
            let url = func_serviceHandling.createUrlWithParams('/Report/CommissionIVReport', paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getInvoiceCommissionList_success({
                        response,
                        level: filterOptions?.level1
                    }));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load invoice commission list";
                    Toaster({ type: "error", msg });

                    dispatch(getInvoiceCommissionList_failure(msg));
                })
        })
    }

    function getInvoiceCommissionDrillDownList(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getInvoiceCommissionDrillDownList_request());

        request(getInvoiceCommissionDrillDownList_request, (axios) => {
            
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;

            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions,
            }
    
            let url = func_serviceHandling.createUrlWithParams('/Report/SalesPersonIVReportDrillDown', paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getInvoiceCommissionDrillDownList_success({
                        response,
                        level: filterOptions?.level1
                    }));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load invoice commission drill down list";
                    Toaster({ type: "error", msg });

                    dispatch(getInvoiceCommissionDrillDownList_failure(msg));
                })
        })
    }

    function getCreditNoteCommissionList(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getCreditNoteCommissionList_request());

        request(getCreditNoteCommissionList_request, (axios) => {
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;

            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions,
            }
    
            let url = func_serviceHandling.createUrlWithParams('/Report/CommissionCNReport', paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getCreditNoteCommissionList_success({
                        response,
                        level: filterOptions?.level1
                    }));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load credit note commission list";
                    Toaster({ type: "error", msg });

                    dispatch(getCreditNoteCommissionList_failure(msg));
                })
        })
    }

    function getCreditNoteCommissionDrillDownList(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getCreditNoteCommissionDrillDownList_request());

        request(getCreditNoteCommissionDrillDownList_request, (axios) => {
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;

            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions,
            }
    
            let url = func_serviceHandling.createUrlWithParams('/Report/SalesPersonCNReportDrillDown', paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getCreditNoteCommissionDrillDownList_success({
                        response,
                        level: filterOptions?.level1
                    }));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load credit note commission drill down list";
                    Toaster({ type: "error", msg });

                    dispatch(getCreditNoteCommissionDrillDownList_failure(msg));
                })
        })
    }

    function updateInvoiceReportingData(date, agentType = "Salesperson") {
        dispatch(updateInvoiceReportingData_request());

        request(updateInvoiceReportingData_request, (axios) => {    
            axios.post('/Report/PumpSalesIVDataSnapShot/' + date + "?agentType=" + agentType)
                .then((response) => {
                    dispatch(updateInvoiceReportingData_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update sales person invoice commission report data";
                    Toaster({ type: "error", msg });

                    dispatch(updateInvoiceReportingData_failure(msg));
                })
        })
    }

    function updateCreditNoteReportingData(date, agentType = "Salesperson") {
        dispatch(updateCreditNoteReportingData_request());

        request(updateCreditNoteReportingData_request, (axios) => {    
            axios.post('/Report/PumpSalesCNDataSnapShot/' + date + "?agentType=" + agentType)
                .then((response) => {
                    dispatch(updateCreditNoteReportingData_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update sales person credit note report data";
                    Toaster({ type: "error", msg });

                    dispatch(updateCreditNoteReportingData_failure(msg));
                })
        })
    }

    function getPOSCountReport(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getPOSCountReport_request());

        request(getPOSCountReport_request, (axios) => {  
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;

            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions,
            }
    
            let url = func_serviceHandling.createUrlWithParams('/Report/GetPosCountReport', paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getPOSCountReport_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load POS count data";
                    Toaster({ type: "error", msg });

                    dispatch(getPOSCountReport_failure(msg));
                })
        })
    }

    function getAllPOSCountReport(pageSize, filterOptions = {}) {
        dispatch(getAllPOSCountReport_request());

        request(getAllPOSCountReport_request, (axios) => {  
            let paramObj = {
                limit: pageSize,
                ...filterOptions,
            }
    
            let url = func_serviceHandling.createUrlWithParams('/Report/getPOSCountReport', paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getAllPOSCountReport_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load all POS count data";
                    Toaster({ type: "error", msg });

                    dispatch(getAllPOSCountReport_failure(msg));
                })
        })
    }

    function getBillingSetupReport(type) {
        dispatch(getBillingSetupReport_request());

        let path = "/Report/GetComWithoutBillingSetup";
        switch (type) {
            case COM_WITHOUT_BILLING_SETUP:
                path = "/Report/GetComWithoutBillingSetup"; break;
            case COM_WITHOUT_DEFAULT_PRODUCT:
                path = "/Report/GetComWithNoDefaultProduct"; break;
            case COM_WITHOUT_BILLING_SETUP_AND_HAS_MISSING_OUTLET:
                path = "/Report/GetMissingOutletFromBillingSetup"; break;
        }

        request(getBillingSetupReport_request, (axios) => {    
            axios.get(path)
                .then((response) => {
                    dispatch(getBillingSetupReport_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load billing setup report data";
                    Toaster({ type: "error", msg });

                    dispatch(getBillingSetupReport_failure(msg));
                })
        })
    }

    function getTrialCOMReport(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getTrialCOMReport_request());

        let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
        let offset = isOffsetValid? pageNo * pageSize:0;

        let paramObj = {
            offset: offset,
            limit: pageSize,
            sort: sort,
            ...filterOptions,
        }

        let url = func_serviceHandling.createUrlWithParams("/Report/GetTrialComReport", paramObj);

        request(getTrialCOMReport_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(getTrialCOMReport_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load trial COM data";
                    Toaster({ type: "error", msg });

                    dispatch(getTrialCOMReport_failure(msg));
                })
        })
    }

    function getStoreReport(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getStoreReport_request());

        let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
        let offset = isOffsetValid ? pageNo * pageSize : 0;

        let paramObj = {
            offset: offset,
            limit: pageSize,
            sort: sort,
            ...filterOptions,
        };

        let url = func_serviceHandling.createUrlWithParams("/Report/GenerateStoreReport", paramObj);

        request(getStoreReport_request, (axios) => {
            axios.get(url)
            .then((response) => {
                dispatch(getStoreReport_success(response));
            })
            .catch((error) => {
                let msg = error?.response?.data?.exceptionMessage
                ? error.response.data.exceptionMessage
                : "Failed to load store data";
                Toaster({ type: "error", msg });

                dispatch(getStoreReport_failure(msg));
            });
        });
    }

    function getFullStoreReport() {
        dispatch(getFullStoreReport_request());

        let paramObj = {
            offset: 0,
            limit: 0,
        };

        let url = func_serviceHandling.createUrlWithParams("/Report/GenerateStoreReport", paramObj);

        request(getFullStoreReport_request, (axios) => {
            axios.get(url)
            .then((response) => {
                dispatch(getFullStoreReport_success(response));
            })
            .catch((error) => {
                let msg = error?.response?.data?.exceptionMessage
                ? error.response.data.exceptionMessage
                : "Failed to load full store data";
                Toaster({ type: "error", msg });

                dispatch(getFullStoreReport_failure(msg));
            });
        });
    }

    function getActivationLogReport(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getActivationLogReport_request());

        let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
        let offset = isOffsetValid ? pageNo * pageSize : 0;

        let paramObj = {
            offset: offset,
            limit: pageSize,
            sort: sort,
            ...filterOptions,
        };

        let url = func_serviceHandling.createUrlWithParams("/BillingSetup/GetAllActivationLogInfo", paramObj);

        request(getActivationLogReport_request, (axios) => {
            axios.get(url)
                .then((response) => {
                    dispatch(getActivationLogReport_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage
                        ? error.response.data.exceptionMessage
                        : "Failed to load activation log data";
                    Toaster({ type: "error", msg });

                    dispatch(getActivationLogReport_failure(msg));
                });
        });
    }

    function getApiUsageReport(pageNo, pageSize, sort, filterOptions = {}) {
        dispatch(getApiUsageReport_request());

        request(getApiUsageReport_request, (axios) => {
            let paramObj = {
                ...filterOptions,
            };

            let url = func_serviceHandling.createUrlWithParams("/BillingSetup/GetAllApiUsageInfo", paramObj);

            axios.get(url)
                .then((response) => {
                    dispatch(getApiUsageReport_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage
                        ? error.response.data.exceptionMessage
                        : "Failed to load API usage data";
                    Toaster({ type: "error", msg });

                    dispatch(getApiUsageReport_failure(msg));
                });
        });
    }

    return {
        getLevel1EnabledProductDetailList,
        addProductLevel1,
        deleteProductLevel1,

        getLevel2EnabledProductDetailList,
        getLevel2CommissionPercentage,
        addProductLevel2,
        deleteProductLevel2,
        updateLevel2CommissionPercentage,

        getInvoiceCommissionList,
        getCreditNoteCommissionList,
        getInvoiceCommissionDrillDownList,
        getCreditNoteCommissionDrillDownList,

        updateInvoiceReportingData,
        updateCreditNoteReportingData,
        getPOSCountReport,
        getAllPOSCountReport,

        getBillingSetupReport,
        getTrialCOMReport,
        getStoreReport,
        getFullStoreReport,
        getActivationLogReport,
        getApiUsageReport
    };
}